<template>
    <div id="admin-template" class="row-fluid">
        <div class="span9">
            <router-view :key="$route.fullPath"/>
        </div>
        <div class="span3">
            <router-view name="sidebar" />
        </div>

        <!-- FlashMessage added globally -->
        <FlashMessage :position="'right bottom'" />
    </div>
</template>

<script>

export default {
    name: "AdminTemplate",
    created() {
        this.$store.dispatch('bootstrapOnCreate');

        // Load all the fields and groups, so that they're available if we reload on an edit page
        this.$store.dispatch('customfields/fetchCustomFields');
        this.$store.dispatch('groups/fetchGroups');
    }
}
</script>

<style>

</style>